module.exports = __webpack_public_path__ + "img/女孩3.6b3f8b6a.png";